import MentionsDropdownItem from '../components/MentionsDropdownItem';
export default class MentionableModels {
  /**
   * We store models returned from an API here to preserve order in which they are returned
   * This prevents the list jumping around while models are returned.
   * We also use a hashmap for model IDs to provide O(1) lookup for the users already in the list.
   */
  results = {};
  typed = null;
  searched = [];
  dropdownItemAttrs = {};
  constructor(dropdownItemAttrs) {
    this.dropdownItemAttrs = dropdownItemAttrs;
  }
  init(mentionables) {
    this.typed = null;
    this.mentionables = mentionables;
    for (const mentionable of this.mentionables) {
      this.results[mentionable.type()] = new Map(mentionable.initialResults().map(result => [result.id(), result]));
    }
  }

  /**
   * Don't send API calls searching for models until at least 2 characters have been typed.
   * This focuses the mention results on models already loaded.
   */
  search = async () => {
    if (!this.typed || this.typed.length <= 1) return;
    const typedLower = this.typed.toLowerCase();
    if (this.searched.includes(typedLower)) return;
    for (const mentionable of this.mentionables) {
      for (const model of await mentionable.search(typedLower)) {
        if (!this.results[mentionable.type()].has(model.id())) {
          this.results[mentionable.type()].set(model.id(), model);
        }
      }
    }
    this.searched.push(typedLower);
    return Promise.resolve();
  };
  matches(mentionable, model) {
    return mentionable.matches(model, this.typed?.toLowerCase() || '');
  }
  makeSuggestion(mentionable, model) {
    const content = mentionable.suggestion(model, this.typed);
    const replacement = mentionable.replacement(model);
    const {
      onclick,
      ...attrs
    } = this.dropdownItemAttrs;
    return m(MentionsDropdownItem, Object.assign({
      mentionable: mentionable,
      onclick: () => onclick(replacement)
    }, attrs), content);
  }
  buildSuggestions() {
    const suggestions = [];
    for (const mentionable of this.mentionables) {
      if (!mentionable.enabled()) continue;
      let matches = Array.from(this.results[mentionable.type()].values()).filter(model => this.matches(mentionable, model));
      const max = mentionable.maxStoreMatchedResults();
      if (max) matches = matches.splice(0, max);
      for (const model of matches) {
        const dropdownItem = this.makeSuggestion(mentionable, model);
        suggestions.push(dropdownItem);
      }
    }
    return suggestions;
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/MentionableModels', MentionableModels);